//import { useSelector } from "react-redux"; //Vishy 2025-18-02 build warning - not used
import { api } from "./config/axiosConfig.js";
import { defineCancelApiObject } from "./config/axiosUtils.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

export const SellerAPI = {
  /////////////////////////
  // EVENTS
  ////////////////////////

  getEvents: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/sellers/events/",
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: events derived from BuyerSellerMapping for this seller's buyer list 20-03-2026
  getBuyerListEvents: async () => {
    const { token } = await store.getState().user;
    try {
      const response = await api.request({
        url: "/sellers/buyers/events",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  getBuyerCompanies: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/buyer/companies",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getBuyerCompaniesV2: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/v2/buyer/companies",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  checkEmailExists: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/buyers",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  addNewBuyerToList: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/buyers",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: changed from path param to query param for optional event filter 18-02-2026
  getBuyers: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/v2/browse",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getSellerProfile: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getEventSellerProfile: async (userId, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/event-seller/" + userId,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  updateSellerProfile: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers",
      method: "PUT",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Send OTP for phone verification
    sendOTP: async (phoneNumber, cancel = false) => {
      const { token } = await store.getState().user;
  
      const response = await api.request({
        url: "sellers/send-otp",
        method: "POST",
        data: { phoneNumber },
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[SellerAPI.sendOTP.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    },
  
    // Verify OTP for phone verification
    verifyOTP: async (phoneNumber, otp, cancel = false) => {
      const { token } = await store.getState().user;
  
      const response = await api.request({
        url: "sellers/verify-otp",
        method: "POST",
        data: { phoneNumber, otp },
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[SellerAPI.verifyOTP.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    },
  

  PostRelevanceBuyer: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "pre-qualify/buyer",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  PostAnnouncement: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "announcements",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  GetAnnouncement: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "announcements",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  GetDashboard: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/dashboard",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getAssets: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/digital-assets",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  getSellerAssets: async (sellerId, cancel = false) => {
        const { token } = await store.getState().user;
    
        const response = await api.request({
          // url: `sellers/digital-assets?sellerId=${sellerId}`,
          url: `sellers/digital-assets/${sellerId}`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
          signal: cancel
            ? cancelApiObject[this.get.name].handleRequestCancellation().signal
            : undefined,
        });
        return responseHandler(response);
      },

  getAssetsByUserId: async (userId, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/digital-assets/" + userId,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  addAsset: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/digital-assets",
      method: "POST",
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  deleteAsset: async (assetId, cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/digital-assets/" + assetId,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: update asset title, URL, summary 25-03-2026
  updateAsset: async (assetId, data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "sellers/digital-assets/" + assetId,
      method: "PATCH",
      data,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: D2 — fetch seller's mapped buyer contacts 26-02-2026
  getBuyerLeads: async (cancel = false) => {
    const { token } = await store.getState().user;

    const response = await api.request({
      url: "sellers/buyers/leads",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  // Claude: Feeds filter support — pass seller-level filter + assetType + pagination 14-03-2026
  getAllSellerAssets: async ({ page = 1, limit = 20, targetCountry, targetIndustries, targetTags, verifiedOnly, assetType } = {}, cancel = false) => {
    const { token } = await store.getState().user;
    const params = { page, limit };
    if (targetCountry?.length) params.targetCountry = targetCountry.join(',');
    if (targetIndustries?.length) params.targetIndustries = targetIndustries.join(',');
    if (targetTags?.length) params.targetTags = targetTags.join(',');
    if (verifiedOnly) params.verifiedOnly = 'true';
    if (assetType) params.assetType = assetType;
    const response = await api.request({
      url: "sellers/assets/all",
      method: "GET",
      params,
      headers: { Authorization: `Bearer ${token}` },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return responseHandler(response);
  },

  //Claude 2026-02-08 Added OG metadata preview API for Inshorts-style feed cards.
  //Calls backend proxy to fetch Open Graph tags (title, description, image) from a URL.
  //response.data.data unwraps NestJS ResponseInterceptor wrapper { data: { ... } }
  getOgPreview: async (url) => {
    const response = await api.request({
      url: "sellers/assets/og-preview",
      method: "GET",
      params: { url },
    });
    return response.data.data;
  },

  // Claude: fetch URL info — moved to shared /utils/fetch-url-info endpoint 01-04-2026
  fetchAssetInfo: async (url) => {
    const response = await api.request({
      url: "utils/fetch-url-info",
      method: "GET",
      params: { url },
    });
    return response.data.data;
  },

  // Claude: distinct productTypeTags from active sellers — for Browse tab 14-03-2026
  getSellerTags: async () => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: "sellers/tags",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: visibility impact preview — how many Discover responses would be affected 10-03-2026
  getVisibilityImpact: async (params, cancel = false) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "sellers/visibility-impact",
      method: "GET",
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  // Claude: seller fetches own statement records for subscription tab 25-Apr-2026
  getStatements: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "sellers/statements",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

};

const cancelApiObject = defineCancelApiObject(SellerAPI);
